var eventify = require('ngraph.events');

module.exports = eventify({});


// WEBPACK FOOTER //
// ./src/bus.js